export default __webpack_public_path__ + "static/media/go_to_market_system_process_preview.62db0f00.png";